import React from "react";
import PageMeta from "../components/PageMeta";
import PageShell from "../components/PageShell";
import { BookingCTA, FeatureCard, Section } from "../components/MarketingPrimitives";
import {
  valueCreationBreakdowns,
  valueCreationMakes,
  valueCreationOperationalises,
} from "../content/siteContent";

const ValueCreationTeams = () => {
  return (
    <PageShell>
      <PageMeta
        title="Value Creation Teams | BestSalesCoach.ai"
        description="See how BestSalesCoach.ai helps Value Creation Teams align Sales, PreSales, GTM leadership, stakeholder context, and execution discipline across complex B2B opportunities."
        canonicalPath="/valuecreationteams"
      />
      <Section
        id="value-teams-hero"
        eyebrow="Value creation teams"
        title="Built for Value Creation Teams That Execute With Discipline"
        description="BestSalesCoach.ai helps GTM teams collaborate, build champions, inspect deal quality, and stay accountable to customer outcomes."
        tone="hero"
      >
        <div className="hero-actions">
          <BookingCTA
            eventName="book_demo_click"
            sourcePage="valuecreationteams"
            ctaClicked="value_creation_teams_demo"
            requestedOffer="BestSalesCoach.ai Platform Demo"
            buyerType="GTM Team"
            urlType="demo"
          />
        </div>
      </Section>

      <Section
        id="why-breakdown"
        eyebrow="Why revenue execution breaks down"
        title="Why revenue execution breaks down"
        description="Revenue teams often carry good intent into a fragmented operating model. The result is activity without enough inspection discipline."
        tone="light"
      >
        <div className="problem-grid">
          {valueCreationBreakdowns.map((item) => (
            <article key={item} className="problem-card">
              <span className="problem-dot" aria-hidden="true" />
              <p>{item}</p>
            </article>
          ))}
        </div>
      </Section>

      <Section
        id="what-makes-vct"
        eyebrow="What makes a team effective"
        title="What makes a Value Creation Team?"
        description="The best teams share one account view, one set of execution priorities, and one standard for what good evidence looks like."
        tone="dark"
      >
        <div className="pill-row">
          {valueCreationMakes.map((item) => (
            <div key={item} className="marketing-pill">
              {item}
            </div>
          ))}
        </div>
      </Section>

      <Section
        id="how-platform-helps"
        eyebrow="How BestSalesCoach.ai operationalises this"
        title="How BestSalesCoach.ai operationalises this"
        description="The platform turns signal, stakeholder, and opportunity discipline into a workflow teams can inspect, coach, and repeat."
        tone="light"
      >
        <div className="marketing-grid marketing-grid-three">
          {valueCreationOperationalises.map((item) => (
            <FeatureCard
              key={item}
              title={item}
              description="Built to make account progress visible, coachable, and accountable across the GTM team."
            />
          ))}
        </div>
      </Section>
    </PageShell>
  );
};

export default ValueCreationTeams;
